import LoginPage from 'pages/login/page'

export const baseRoutes = [{ path: '/login', element: <LoginPage /> }]
